/*
 * SoflePLUS2 builder in the CornePLUS2 layout (theme asset sp2-corne-ui.js).
 * Markup and classes follow the live CornePLUS2 configurator (.cfg, .viewer, .panel, .seg, .opt, .sw, .choose,
 * .total, .buy, #drawer). Prices, stock and rules come from the live store through SP2Rules (sp2-rules.js), the
 * same engine the Sofle product page uses, and the 3D view is the Sofle viewer (sofle-configurator.js).
 * Needs: SP2Rules, SP2Currency, SofleConfigurator, SP2_CONFIG (catalog, looks, hotspots from sp2-config.js).
 */
(function (root) {
  'use strict';

  var QTY = 60;
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  };
  var money = function (cents) { return SP2Rules.formatRM(cents, { compact: true }); };
  var fmt = function (cents, opts) { return SP2Rules.formatRM(cents, opts); };
  var SLOT_LABEL = { socket: 'Hot-swap socket', plate: 'Switch plate', bottom: 'Bottom', case: '3D case', foam: 'Sound dampening' };
  var PART_SLOTS = ['socket', 'plate', 'bottom', 'case', 'foam'];
  var TOOLS = [
    ['explode', 'Exploded view'], ['top', 'Top'], ['bottom', 'Bottom'], ['home', 'Reset view']
  ];
  var LAYERS = [['rgb', 'RGB backlight'], ['keycaps', 'Keycaps'], ['switches', 'Switches']];
  // swatch colours: the same colours CornePLUS2 uses for its matching parts (socket, plate, bottom, case);
  // foam and trackpad have no swatch on CornePLUS2, so they use the nearest tone (see sp2-corne-ui notes)
  var SWATCH = {
    socket: { lp: '#2b2d31', mx: '#c9cdd2' },
    plate: { fr4: '#3b3a2c', cf: 'repeating-linear-gradient(45deg,#1b1c1f 0 3px,#2d2f34 3px 6px)', pp: '#1f2024' },
    bottom: { steel_clear: 'linear-gradient(135deg,#f3f4f5,#a7adb4)', frosted: '#e9eef2' },
    case: { case_3d: '#1d1e21', case_3d_white: '#eeeeea', none: 'clear' },
    foam: { poron_ixpe: '#3a3c41', ixpe: '#d9dadc', lp_poron: '#3a3c41', mx_poron: '#3a3c41', none: 'clear' },
    // switches: CornePLUS2's colour for each switch (cfg3d.js SWITCHES), matched by switch id
    switches: {
      black_cloud: '#161618', whale: '#2f45b8', islet: '#2f45b8', pink_islet: '#e8a08c', spring: '#a8dcc0',
      raptor: '#b4dce0', glede: '#5a3570', winter: '#b8d4f0', autumn: '#f0a830'
    }
  };
  var swatch = function (slot, id) {
    var c = SWATCH[slot] && SWATCH[slot][id];
    if (c === 'clear') return '<i class="sp2-swatch sp2-swatch--clear"></i>';
    return c ? '<i class="sp2-swatch" style="background:' + c + '"></i>' : '<i class="sp2-swatch"></i>';
  };
  // keycap swatches: CornePLUS2's colour for the same keycap (cfg3d.js KEYCAPS). A shinethrough keycap shows a
  // lit letter on its swatch; any other keycap is opaque.
  var KC_THT = 'radial-gradient(circle at 50% 50%,rgba(85,224,240,.16),transparent 62%),linear-gradient(135deg,#1e1f22,#34363b)';
  var KC_THT_W = 'radial-gradient(circle at 50% 50%,rgba(85,224,240,.14),transparent 62%),linear-gradient(135deg,#f6f6f4,#d9dbdd)';
  var KC_LPF = 'radial-gradient(circle at 50% 50%,rgba(85,224,240,.16),transparent 62%),linear-gradient(135deg,#17181b,#2c2e32)';
  var KC_SWATCH = {
    tht_black: KC_THT, tht_black_choc: KC_THT, tht_white: KC_THT_W, tht_white_choc: KC_THT_W,
    lpf_black: KC_LPF, lpf_white: KC_THT_W,
    jwa_black: 'linear-gradient(135deg,#1c1d20,#2c2e32)', jwa_white: 'linear-gradient(135deg,#fafafa,#e9e9e9)',
    lck_silver: 'linear-gradient(135deg,#c9ccd0,#9ea3a9)'
  };
  var keycapSwatch = function (o) {
    var c = KC_SWATCH[o.id];
    if (!c) return o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : '<i class="sp2-swatch"></i>';
    var shine = /shine/i.test(o.label);
    var legend = shine ? (/white/i.test(o.id) ? 'glow-w' : 'glow') : '';
    return '<i class="' + (legend ? 'lit ' + legend : '') + '" style="background:' + c + '">' + (shine ? '<em>A</em>' : '') + '</i>';
  };
  var IMG_OR_SWATCH = function (o) {
    return o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : '<span class="sp2-swatch"></span>';
  };

  function mount(el, cfg) {
    var $ = function (sel) { return el.querySelector(sel); };
    var text = Object.assign({
      consent: 'I understand that with regular shipping (not DDP, delivered duty paid), import duties, taxes, VAT and customs fees are charged to me on delivery.',
      trackpadNote: 'The Large trackpad is included with every build.',
      shippingNote: 'Shipping calculated at checkout.'
    }, cfg.text || {});
    var engine = SP2Rules.createEngine(cfg.catalog, cfg.live || {});
    var state = engine.initialState();
    var ui = { busy: false, feedback: '', feedbackKind: '', drawer: null, copied: false, cart: null };
    var rates = null;
    var estCurrency = 'USD';
    var viewer = null;
    var stage = $('.viewer');
    var panel = $('[data-sp2-panel]');
    var drawer = $('#drawer');
    var tools = $('[data-sp2-tools]');
    var loading = $('[data-sp2-loading]');
    var caption = $('[data-sp2-caption]');
    var codeEl = $('[data-sp2-code]');

    // variant of every option (for the product links and the live stock count), and the keyboard variants
    // (sets, custom base, Build Kit) that mark a SoflePLUS2 build already in the cart
    var VARIANT = {};
    (cfg.catalog.slots || []).forEach(function (s) {
      VARIANT[s.id] = {};
      (s.options || []).forEach(function (o) { VARIANT[s.id][o.id] = o.variant; });
    });
    var BASE_IDS = [cfg.catalog.base && cfg.catalog.base.variant, cfg.catalog.kit && cfg.catalog.kit.variant]
      .concat((cfg.catalog.presets || []).map(function (p) { return p.variant; })).filter(Boolean).map(Number);
    var liveQty = function (vid) { var l = cfg.live && cfg.live[vid]; return l && l.qty != null ? l.qty : null; };
    var storeRoot = function () { return (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/'; };

    // build code, like CornePLUS2's CP2-BLK-CF-...: set, then each part
    var CODE = {
      set: { starter: 'STR', standard: 'STD', signature: 'SIG' },
      socket: { lp: 'LP', mx: 'MX' }, plate: { fr4: 'FR4', cf: 'CF', pp: 'PP' }, bottom: { steel_clear: 'STL', frosted: 'FRS' },
      case: { case_3d: 'C3D', case_3d_white: 'WHC', none: 'NC' },
      foam: { poron_ixpe: 'PRN', ixpe: 'IXP', lp_poron: 'LPP', mx_poron: 'MXP', none: 'NF' }
    };
    function buildCode(ev) {
      var head = ev.route === 'kit' ? 'KIT' : ev.match ? (CODE.set[ev.match] || String(ev.match).toUpperCase()) : 'CUS';
      var parts = PART_SLOTS.map(function (s) {
        if (state.kit && s !== 'socket' && !state.kitParts[s]) return null;
        var id = state.parts[s];
        return (CODE[s] && CODE[s][id]) || String(id).toUpperCase();
      }).filter(Boolean);
      return ['SP2', head].concat(parts).join('-');
    }

    // ---------- 3D view and its buttons ----------
    function renderTools() {
      tools.innerHTML = '<div class="vgroup">' + TOOLS.map(function (t) {
        return '<button type="button" class="press" data-act="' + t[0] + '">' + t[1] + '</button>';
      }).join('') + '</div><div class="vgroup">' + LAYERS.map(function (t) {
        return '<button type="button" class="press" data-layer="' + t[0] + '" aria-pressed="false" disabled>' + t[1] + '</button>';
      }).join('') + '</div>';
    }
    renderTools();

    function syncLayers() {
      var sel = engine.selection(state);
      tools.querySelectorAll('[data-layer]').forEach(function (b) {
        var k = b.getAttribute('data-layer');
        var has = k === 'rgb' ? true : sel[k] && sel[k].picks.length > 0;
        b.disabled = !viewer || !has;
        b.title = has ? '' : 'Pick ' + k + ' to see them';
      });
    }

    if (cfg.glbUrl && root.SofleConfigurator) {
      SofleConfigurator.createViewer(stage, {
        glb: cfg.glbUrl, looks: root.SP2_CONFIG.looks, hotspots: root.SP2_CONFIG.hotspots,
        onProgress: function (p) { if (loading) loading.textContent = 'Loading 3D… ' + Math.round(p * 100) + '%'; },
        onCaption: function (list) { if (caption) { caption.textContent = list.join(' '); } }
      }).then(function (vw) {
        viewer = vw;
        if (loading) loading.remove();
        viewer.show(engine.selection(state));
        syncLayers();
      }).catch(function (err) {
        if (loading) loading.textContent = 'The 3D view couldn’t load on this device.';
        console.error(err);
      });
    } else if (loading) {
      loading.remove();
    }

    tools.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !viewer) return;
      var act = b.getAttribute('data-act');
      if (act) {
        if (act === 'home') { viewer.setExploded(false); viewer.view('home'); return; }
        if (act === 'explode') { viewer.setExploded(b.getAttribute('aria-pressed') !== 'true'); b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true'); return; }
        viewer.view(act);
        return;
      }
      var layer = b.getAttribute('data-layer');
      if (layer) {
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on);
        b.classList.toggle('on', on);
        if (layer === 'rgb') viewer.setRGB(on);
        else if (layer === 'keycaps') viewer.setKeycaps(on);
        else if (layer === 'switches') viewer.setSwitches(on);
      }
    });

    // ---------- choices (the panel) ----------
    function badge(price, compare) { return compare ? ' <span class="sp2-badge">-' + Math.round((compare - price) * 100 / compare) + '%</span>' : ''; }

    function setsHtml(ev) {
      // no prices on the model buttons, as on CornePLUS2: the estimated total shows the cost
      var sets = ev.presets.map(function (p) {
        return '<button type="button" class="press' + (p.active ? ' on' : '') + '" data-set="' + p.id + '"' + (p.available ? '' : ' disabled') + '>' +
          esc(p.label) + '</button>';
      }).join('');
      var kit = ev.kit ? '<button type="button" class="press' + (ev.kit.active ? ' on' : '') + '" data-kit="' + ev.kit.id + '"' + (ev.kit.available ? '' : ' disabled') + '>' +
        esc(ev.kit.label) + '</button>' : '';
      return '<div class="seg">' + sets + kit + '</div>';
    }

    function partOpt(ev, slot, kitMode, kitOn) {
      var meta = ev.slots[slot];
      var opts = ev.options[slot].filter(function (o) { return !kitMode || o.id !== 'none'; });
      var included = kitMode ? (kitOn ? 'optional' : 'optional') : (meta.showPrice ? '' : 'included');
      var chips = opts.map(function (o) {
        var on = kitMode ? kitOn && o.selected : o.selected;
        var delta = on ? '' : (kitMode ? (o.price ? '+' + money(o.price) : '') : (meta.showPrice && o.delta ? fmt(o.delta, { sign: true, compact: true }) : ''));
        var why = o.reason ? ' <em>' + esc(o.reason) + '</em>' : '';
        return '<button type="button" class="press' + (on ? ' on' : '') + '" data-part="' + slot + '" data-id="' + o.id + '"' + (o.available ? '' : ' disabled') + '>' +
          swatch(slot, o.id) + esc(o.label) + (delta ? ' <em>' + delta + '</em>' : '') + why + '</button>';
      }).join('');
      var head = '<span>' + esc(meta.label || SLOT_LABEL[slot]) + '</span><span>' + (kitMode ? (kitOn ? 'Included' : 'Optional') : (meta.showPrice ? 'Choose' : 'Included')) + '</span>';
      return '<div class="opt"><h4>' + head + '</h4><div class="sw">' + chips + '</div></div>';
    }

    function chooseHtml(kind, ev) {
      var picks = ev.options[kind].filter(function (o) { return o.selected; });
      var skipped = state[kind + 'Skipped'];
      var status = skipped ? 'None' : picks.length ? picks.length + ' type' + (picks.length > 1 ? 's' : '') : 'Choose, or skip';
      var label = kind === 'switches' ? 'Switches · ' + QTY + ' each' : 'Keycaps';
      var names = skipped ? (kind === 'switches' ? 'Not needed' : 'Not needed') : picks.length ? picks.map(function (o) { return o.label; }).join(', ') : 'Choose a set';
      var price = picks.length ? money(picks.reduce(function (s, o) { return s + (kind === 'switches' ? o.price * QTY : o.price); }, 0)) : '';
      return '<button type="button" class="choose press' + (ui.drawer === kind ? ' open' : '') + '" data-open="' + kind + '">' +
        '<span><small>' + label + '</small>' + esc(names) + '</span><b>' + (price ? price + ' · ' : '') + (ui.drawer === kind ? 'Close' : 'Change') + '</b></button>';
    }

    function linesHtml(ev) {
      return '<div class="sp2-lines">' + ev.lines.map(function (l) {
        return '<div><span>' + esc(l.label) + (l.qty > 1 ? ' × ' + l.qty : '') + '</span><span>' + (l.amount ? fmt(l.amount) : '—') + '</span></div>';
      }).join('') + '</div>';
    }

    function renderPanel(ev) {
      var kitMode = ev.route === 'kit';
      var parts = PART_SLOTS.map(function (s) {
        if (kitMode && s !== 'socket') return partOpt(ev, s, true, !!ev.kit.parts[s]);
        return partOpt(ev, s, false);
      }).join('');
      var issues = ev.issues.filter(function (i) { return i.code !== 'consent'; });
      var issueHtml = issues.length ? '<ul class="sp2-issues">' + issues.map(function (i) { return '<li>' + esc(i.message) + '</li>'; }).join('') + '</ul>' : '';
      var ok = ev.canAddToCart && !ui.busy;
      // USD estimate of the total on screen. The total is already the shopper's market price (Shopify adds the
      // +7% for buyers outside Malaysia in the prices it sends), so no extra percentage is added here.
      var usd = estimateText(ev.total);
      panel.innerHTML =
        setsHtml(ev) +
        parts +
        '<p class="sp2-note">' + esc(text.trackpadNote) + '</p>' +
        chooseHtml('switches', ev) +
        chooseHtml('keycaps', ev) +
        linesHtml(ev) +
        issueHtml +
        '<label class="sp2-consent"><input type="checkbox" data-consent' + (state.consent ? ' checked' : '') + '><span>' + esc(text.consent) + '</span></label>' +
        '<div class="total"><span>Estimated total' + (usd ? '<br>' + esc(usd) : '') + '</span><strong>' + fmt(ev.total) + '</strong></div>' +
        (ui.feedback ? '<p class="sp2-feedback is-' + ui.feedbackKind + '">' + esc(ui.feedback) + '</p>' : '') +
        '<button type="button" class="buy press" data-add' + (ok ? '' : ' disabled') + '><span>' + (ui.busy ? 'Going to checkout…' : 'Checkout') + '</span></button>' +
        '<p class="sp2-help">' + esc(text.shippingNote) + '</p>';
    }

    // ---------- the drawer: switches and keycaps (same look as the CornePLUS2 keycap drawer) ----------
    function renderDrawer(ev) {
      if (!ui.drawer) { drawer.classList.add('closed'); drawer.innerHTML = ''; return; }
      var kind = ui.drawer;
      // sold-out keycaps leave the list and come back when they are in stock; a keycap already picked stays visible
      var list = ev.options[kind].filter(function (o) { return kind !== 'keycaps' || o.available || o.selected; });
      var rows = list.map(function (o) {
        var vid = VARIANT[kind] && VARIANT[kind][o.id];
        var reason = o.reason;
        // switches: CornePLUS2's wording, with the live count ("Only 18 left, needs 60")
        if (kind === 'switches' && !o.available && vid) {
          var q = liveQty(vid);
          reason = q > 0 ? 'Only ' + q + ' left, needs ' + QTY : 'Out of stock';
        }
        var why = reason ? '<small>' + esc(reason) + '</small>' : '';
        var price = kind === 'switches' ? money(o.price) + ' ea' : money(o.price);
        var pick = '<button type="button" class="kc press' + (o.selected ? ' on' : '') + '" data-many="' + kind + '" data-id="' + o.id + '"' + (o.available ? '' : ' disabled') + '>' +
          (kind === 'switches' ? swatch('switches', o.id) : keycapSwatch(o)) + '<div><b>' + esc(o.label) + '</b>' +
          (kind === 'switches' && !reason ? '<small>' + QTY + ' per set</small>' : '') + why + '</div><span>' + price + '</span></button>';
        // each row links to its variant on the store, for bigger photos (as on CornePLUS2)
        var link = vid ? '<a class="kc-link" href="' + storeRoot() + 'variants/' + vid + '" target="_blank" rel="noopener" aria-label="Open ' + esc(o.label) + ' on the store">↗</a>' : '';
        return '<div class="kc-row">' + pick + link + '</div>';
      }).join('');
      var skipped = state[kind + 'Skipped'];
      drawer.classList.remove('closed');
      drawer.innerHTML =
        '<div class="dh"><div><small class="mono">' + (kind === 'switches' ? 'Switches · sold in sets of ' + QTY : 'Keycaps') + '</small><h3>' + (kind === 'switches' ? 'Pick a switch' : 'Pick a keycap set') + '</h3></div>' +
        '<button type="button" class="x press" data-drawer-close aria-label="Close">×</button></div>' +
        rows +
        '<button type="button" class="kc skip press' + (skipped ? ' on' : '') + '" data-skip="' + kind + '">' + (kind === 'switches' ? 'I don’t need any switches' : 'I don’t need keycaps') + '</button>' +
        '<button type="button" class="buy press" data-drawer-close>Done</button>';
    }

    // ---------- estimate, cart ----------
    function estimateText(total) {
      if (!rates) return '';
      var r = rates.rates[estCurrency] ? estCurrency : 'USD';
      return SP2Currency.estimate(total, r, rates);
    }

    function render() {
      var ev = engine.evaluate(state);
      renderPanel(ev);
      renderDrawer(ev);
      if (codeEl) codeEl.textContent = buildCode(ev);
      syncLayers();
      if (viewer) viewer.show(engine.selection(state));
    }

    function update(next) {
      if (next === state) return;
      state = next;
      ui.feedback = ''; ui.cart = null;
      render();
    }

    // Checkout, as on CornePLUS2: one SoflePLUS2 build per order. An earlier SoflePLUS2 build in the cart (its
    // tagged lines, plus any loose SoflePLUS2 set, custom base or Build Kit) is removed first; anything else in the
    // cart stays. Then this build is added and the shopper goes straight to checkout.
    function isSofleBuild(it) {
      var b = it.properties && it.properties._build;
      return (typeof b === 'string' && (b.indexOf('SP2 ') === 0 || b.charAt(0) === '#')) || BASE_IDS.indexOf(it.variant_id) >= 0;
    }
    function addToCart() {
      var ev = engine.evaluate(state);
      var items = engine.cartItems(state, engine.newBuildId());
      if (!items) return;
      var code = buildCode(ev);
      var link = location.origin + location.pathname + '?sp2=' + engine.encode(state);
      items.forEach(function (it) {
        it.properties._build = 'SP2 ' + it.properties._build;
        // the keyboard line carries the whole build, so the order shows it (as CornePLUS2's base line does)
        if (BASE_IDS.indexOf(it.id) >= 0) Object.assign(it.properties, { Package: ev.title, Build: code, 'Build link': link });
      });
      ui.busy = true; ui.feedback = ''; render();
      var r0 = storeRoot();
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      fetch(r0 + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var old = (cart.items || []).filter(isSofleBuild);
        if (!old.length) return null;
        var updates = {};
        old.forEach(function (it) { updates[it.key] = 0; });
        return fetch(r0 + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates }) });
      }).then(function () {
        // the cart lists the newest line first: send in reverse so the keyboard leads and the keycaps come last
        return fetch(r0 + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items.slice().reverse() }) });
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Couldn’t add this build to the cart.');
          location.href = r0 + 'checkout';
        });
      }).catch(function (err) {
        ui.busy = false; ui.feedback = err.message + ' Please try again.'; ui.feedbackKind = 'error'; render();
      });
    }

    // ---------- events ----------
    el.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.disabled) return;
      if (b.hasAttribute('data-drawer-close')) { ui.drawer = null; return render(); }
      if (b.hasAttribute('data-open')) {
        var k = b.getAttribute('data-open');
        ui.drawer = ui.drawer === k ? null : k;
        return render();
      }
      if (b.dataset.set) return update(engine.applyPreset(state, b.dataset.set));
      if (b.hasAttribute('data-kit')) return update(engine.setKit(state, true));
      if (b.dataset.part) {
        var slot = b.dataset.part;
        if (state.kit && state.kitParts[slot] && state.parts[slot] === b.dataset.id) return update(engine.setKitPart(state, slot, false));
        return update(engine.setPart(state.kit ? engine.setKitPart(state, slot, true) : state, slot, b.dataset.id));
      }
      if (b.dataset.many) return update(engine.toggle(state, b.dataset.many, b.dataset.id));
      if (b.hasAttribute('data-skip')) { var sk = b.getAttribute('data-skip'); return update(engine.skip(state, sk, !state[sk + 'Skipped'])); }
      if (b.hasAttribute('data-add')) return addToCart();
      if (b.hasAttribute('data-copy')) {
        var link = location.origin + location.pathname + '?sp2=' + engine.encode(state);
        (navigator.clipboard ? navigator.clipboard.writeText(link) : Promise.reject()).then(function () {
          b.querySelector('span').textContent = 'Copied'; setTimeout(function () { b.querySelector('span').textContent = 'Copy build link'; }, 1600);
        });
      }
    });
    el.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-consent')) update(engine.setConsent(state, e.target.checked));
    });

    // the link to a build (?sp2=...) opens that build
    var params = new URLSearchParams(location.search);
    if (params.get('sp2')) state = engine.decode(params.get('sp2'));

    // daily exchange rates for the USD estimate (European Central Bank, with a fallback source)
    if (root.SP2Currency && SP2Currency.loadRates) SP2Currency.loadRates().then(function (r) { rates = r; render(); }, function () { /* no estimate */ });

    render();
    return { get state() { return state; }, engine: engine, render: render };
  }

  function autoMount() {
    document.querySelectorAll('[data-sp2-corne]').forEach(function (el) {
      if (el.__sp2) return;
      var read = function (sel) { var s = el.querySelector(sel); return s ? JSON.parse(s.textContent) : null; };
      var conf = root.SP2_CONFIG || {};
      var settings = read('script[data-sp2c-settings]') || {};
      el.__sp2 = mount(el, Object.assign({
        catalog: conf.catalog, live: read('script[data-sp2c-live]') || {}
      }, settings));
    });
  }

  root.SP2CorneBuilder = { mount: mount, autoMount: autoMount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoMount);
  else autoMount();
  document.addEventListener('shopify:section:load', autoMount);
})(typeof self !== 'undefined' ? self : this);
